import Shutter from 'sounds/shutter.mp3';

export const SHOT_CONFIG = {
  LOADING_TIME: 5,
  FLASH_TIME: 0.6,
  VIDEO_STOP_TIME: 1,
  DEFAULT_SHOT_COUNT: 6,
  MIRROR_MODE: true, // 거울모드 on/off (true: 거울모드, false: 일반모드)
  VIDEO_CONSTRAINTS: {
    aspectRatio: 1.25,
    advanced: [
      { width: { exact: 2880 }, height: { exact: 3600 } },
      { width: { exact: 2160 }, height: { exact: 2700 } },
      { width: { exact: 1440 }, height: { exact: 1800 } },
      { width: { exact: 1080 }, height: { exact: 1350 } },
      { width: { exact: 720 }, height: { exact: 900 } },
      { width: { exact: 480 }, height: { exact: 600 } },
    ],
  },
  SHUTTER_SOUND: new Audio(Shutter),
};
